<template>
  <v-container>
    <v-card
        class="mx-auto my-12"
        max-width="410"
        width="410"
        v-if="!state && requiresPin"
      >
        <v-card-title>Password</v-card-title>
        <v-card-subtitle>This meeting requires a password to join.</v-card-subtitle>
        <v-card-text>
          <v-text-field
            v-model="pinPassword"
            label=""
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn 
            class="mx-2"
            color="info"
            @click="validatePinPassword()"
          >
            Validate
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card
        class="mx-auto my-12"
        max-width="410"
        width="410"
        v-if="!state && !requiresPin && conf.name && (!this.user || this.user.user_id == 'guest')"
      >
        <v-card-title>What is your name?</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="guestName"
            label=""
            v-on:change="setUserName(guestName)"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn 
            v-if="(!state && guestName)"
            class="mx-2"
            color="info"
            @click="connectWithBestToken()"
          >
            Join
          </v-btn>
        </v-card-actions>
      </v-card>
  </v-container>
</template>

<script >

import ConferenceCommon from '../mixins/conferencecommon';
import Vue from 'vue';

export default Vue.extend({
  data: function() {
    return {
      guestName: null,
    }
  },
  mixins: [ConferenceCommon],
  props: {showJoiningInfo: Boolean},
  methods: {
    validatePinPassword: function () {
      console.log('validatePinPassword');
      console.log(this.$store.state.pinPassword);
        this.$store.dispatch('conference/setConferenceByUrlToken', {token: this.$route.params.confId, pin: this.pinPassword});
    },
    setUserName: function(name) {
      this.$store.commit('sip/addExtraHeader', {CONF_USER_DISPLAY_NAME:name});
      this.$store.commit('sip/addExtraHeader', {CONF_USER_DISPLAY_NUMBER:'join.rinble.com/#/'+ this.$route.params.confId});
    }
  },
  computed: {
   
  },
  async mounted() {
    
  },
  watch: {

  }
})
</script>
